// Copyright (c) Jonathan Ferraz.
// Licensed under the MIT license.

import { Fragment, ReactNode, useEffect, useState } from 'react';

import { Footer } from './styles';
import useScreenSize from 'hooks/useScreenSize';
import useScrollPosition from 'hooks/useScrollPosition';
import useScrollTo from 'hooks/useScrollTo';

export const FixedFooter = () => {
  const [text, setText] = useState<ReactNode>(
    <p>
      <b>Send request</b> to work with us.
    </p>
  );

  const scrollTo = useScrollTo();
  const scrollPosition = useScrollPosition();
  const screenSize = useScreenSize();

  const isMobileQuery = () => {
    if (screenSize === 'sm' || screenSize === 'xs') {
      return true;
    }

    return false;
  };

  const hero = document.getElementById('hero');
  const showcase = document.getElementById('showcase');
  const testimonials = document.getElementById('testimonials');
  const marketSays = document.getElementById('market-says');
  const areMissing = document.getElementById('are-missing');
  const contact = document.getElementById('contact');

  // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
  const heroOffset: any = hero?.offsetTop! as any;
  // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
  const showcaseOffset: any = showcase?.offsetTop! as any;
  // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
  const testimonialsOffset: any = testimonials?.offsetTop! as any;
  // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
  const marketSaysOffset: any = marketSays?.offsetTop! as any;
  // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
  const areMissingOffset: any = areMissing?.offsetTop! as any;
  // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
  const contactOffset: any = contact?.offsetTop! as any;

  useEffect(() => {
    if (window.location.pathname === '/') {
      if (scrollPosition >= heroOffset) {
        setText(
          <Fragment>
            <b>Send request</b> to work with us.
          </Fragment>
        );
      }
      if (scrollPosition >= showcaseOffset - 670) {
        setText(
          <Fragment>
            <b>Portfolio</b> don’t be shy to view.
          </Fragment>
        );
      }
      if (scrollPosition >= testimonialsOffset - 670) {
        setText(
          <Fragment>
            <b>Reviews</b> from our lovely clients.
          </Fragment>
        );
      }
      if (scrollPosition >= marketSaysOffset - 670) {
        setText(
          <Fragment>
            <b>CR Improvement</b> design always sells.
          </Fragment>
        );
      }
      if (scrollPosition >= areMissingOffset - 670) {
        setText(
          <Fragment>
            <b>Are you ready?</b> Let’s start the project!
          </Fragment>
        );
      }
      if (scrollPosition >= contactOffset - 670) {
        setText(
          <Fragment>
            <b>Thank you!</b> Great things are coming.
          </Fragment>
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scrollPosition]);

  return (
    <Footer>
      <p>{text}</p>
      <button
        onClick={() => {
          scrollTo({
            to: '#contact',
            duration: 1200,
            offset: isMobileQuery() ? 130 : -200,
          });
        }}
      >
        <span>Send</span>
      </button>
    </Footer>
  );
};
